<template>
    <MainLayout ref="mainLayoutRef" :hasRight="true" leftWidth="325px" rightWidth="400px" :collapseLeft="false"
        :collapseRight="false">
        <News slot="header"></News>

        <Left slot="left" :routeId="routeId" @routeItemClick="viewRouteDetail" @gridGroupClick="hanleOnGridGroupClick"
            @tabChange="handleLeftHeaderTabChange" @deleteSuccess="handleLeftDeleteSuccess"></Left>
        <div slot="main" style="position: relative;height:100%;width:100%; padding:5px">
            <MapContainer ref="mapContainer" slot="main" :zoomToolConfig="zoomToolConfig"
                :bottomToolConfig="bottomToolConfig">

                <template slot="openlayer">

                    <HivesPoints :hives="hiveList" :hivesTopShow="false"></HivesPoints>
                    <OpenlayerGridLayer :zIndex="21" :gridList="gridList" :popoverConfig="gridPopoverConfig"
                        @selectFeature="handleGridSelect">
                    </OpenlayerGridLayer>

                    <OlWaylineLayer v-if="!loadingRoute" :waylineConfig="waylineConfig" :editable="false">
                    </OlWaylineLayer>
                </template>
            </MapContainer>
        </div>
        <template slot="right">
            <div style="height: calc(100% - 2px);position: relative;">
                <WaylineSetting :waylineInfo="waylineInfo" :editable="false"></WaylineSetting>
            </div>

        </template>
    </MainLayout>

</template>

<script>

import News from '../mainPage/components/news/News.vue';
import MainLayout from '@/components/layout'
import MapContainer from '@/components/map/MapContainer/MapContainer.vue';
import Left from './components/Left.vue'
import WaylineSetting from './RouteEditor/components/WaylineSetting'
import OlWaylineLayer from './RouteEditor/components/Map/OlWaylineLayer.vue';
import HivesPoints from '../mainPage/mapComponents/HivesPoints.vue';
import Api from './main/api.js';


import OpenlayerGridLayer from "@/page/business/chengguan/components/OpenlayerGridLayer"

export default {
    components: { News, MainLayout, MapContainer, Left, HivesPoints, OpenlayerGridLayer, OlWaylineLayer, WaylineSetting },
    data() {
        document.title = '航线规划';
        return {
            zoomToolConfig: {
                showViewMode: false,
            },
            bottomToolConfig: {
                showFly: false
            },
            routeId: "",
            gridId: "",
            hiveList: [],

            waylineInfo: {
                config: {}
            },
            loadingRoute: true,

            airlineConfig: {},


            gridList: [],
            gridPopoverConfig: {
                checkCountVisible: false,//是否显示巡查次数
                eventCountVisible: false,//是否显示疑似事件发现数
                heightLimitVisible: true,//是否显示高度限制
                detailButtonVisible: false,//是否显示进入网格按钮
                routeDetailButtonVisible: true,//是否显示查看航线按钮
                routeAddButtonVisible: true,//是否显示规划航线按钮
                onRouteDetailButtonClick: (e) => {
                    this.handleGridRouteDetailButtonClick(e);
                },//点击查看航线按钮回调
                onRouteAddButtonClick: (e) => {
                    this.handleGridRouteAddButtonClick(e);
                },//点击规划航线按钮回调
            }


        };
    },
    computed: {
        waylineConfig() {
            return this.waylineInfo.config || {}
        },
    },
    watch: {
    },

    methods: {

        /**
         * 查看航线详情
         *
         * @param routeInfo 路线信息
         */
        viewRouteDetail(routeInfo) {
            if (routeInfo) {
                this.loadingRoute = true;
                this.$nextTick(() => {
                    let cloneWaylineInfo = JSON.parse(JSON.stringify(routeInfo))
                    let coordinates = cloneWaylineInfo.coordinates
                    let waylineConfig = {}
                    if (coordinates && typeof coordinates === 'string') {
                        const coordinatesObj = JSON.parse(coordinates)
                        waylineConfig = coordinatesObj.routePoints
                    }
                    cloneWaylineInfo.config = waylineConfig
                    this.waylineInfo = cloneWaylineInfo;
                    this.loadingRoute = false;
                    this.showRight();
                })
            }
        },
        /**
         * 处理左侧删除航线成功的事件
         */
        handleLeftDeleteSuccess(data) {
            this.loadingRoute = true;
            this.hideRight();
        },

        async getSiteList() {
            let res = await Api.getSiteList();
            this.hiveList = res.rows;
        },
        /**
         * 根据id查询航线信息
         *
         * @param {number} id - 航线id
         * @returns {Promise<any>} - 返回一个Promise对象，resolve时返回航线信息，reject时返回错误信息
         */
        getRouteInfo(id) {

            return new Promise((resolve, reject) => {
                Api.getRouteInfo(id).then(res => {

                    if (res.code == 200) {
                        resolve(res.data)
                    }
                    reject(res.msg)
                })
            })
        },

        /**
         * 处理左侧网格分组点击事件
         *
         * @param data 包含网格数据的对象
         */
        hanleOnGridGroupClick(data) {
            // data.gridList[0].hasRoute = 'Y'
            console.log(data)
            this.gridList = data.gridList || []
            if (this.$refs.mapContainer) {
                this.$nextTick(() => {
                    const { ltLongitude, ltLatitude, rbLongitude, rbLatitude } = data
                    if (ltLongitude && ltLatitude && rbLongitude && rbLatitude) {
                        let extent = [ltLongitude, rbLatitude, rbLongitude, ltLatitude]
                        this.$refs.mapContainer.fitExtent(extent, { padding: [20, 20, 20, 20] })
                    }
                })
            }
        },

        /**
         * 处理网格弹框“规划航线”按钮点击事件
         *
         * @param gridData 事件对象，包含gridGroupId和id属性
         */
        handleGridRouteAddButtonClick(gridData) {
            console.log(gridData)
            const { gridGroupId, id } = gridData
            this.$router.push({
                path: '/route/create',
                query: {
                    gridGroupId,
                    gridId: id,

                }
            })
        },
        /**
         * 处理网格路由详情按钮点击事件
         *
         * @param gridData 网格数据对象
         */
        handleGridRouteDetailButtonClick(gridData) {
            console.log(gridData)
            const { gridGroupId, id } = gridData
            this.getRouteListByGridId(id).then(data => {
                if (data) {
                    this.$router.push({
                        path: `/route/edit/${data.id}`,
                        query: {
                            gridGroupId,
                            gridId: id,

                        }
                    })
                }
            })

        },
        handleGridSelect(feature) {
            console.log(feature)
            if (feature) {
                const gridInfo = feature.get("gridInfo")

                if (gridInfo) {
                    const { id } = gridInfo
                    this.getRouteListByGridId(id).then(data => {

                        if (data) {
                            let { coordinates } = data
                            if (coordinates) {
                                let coordObj = JSON.parse(coordinates)
                                let waylineConfig = coordObj.routePoints
                                this.airlineConfig = waylineConfig
                                this.airlineConfig.init = true;
                                this.routeObj = {
                                    ...this.routeObj,
                                    lineType: waylineConfig.type,
                                    SeeShow: true,
                                    rightShow: true,

                                }

                            }

                        }
                    })
                }
            }
        },
        async getRouteListByGridId(gridId) {
            return new Promise((resolve, reject) => {
                console.log(gridId, "gridId")
                let param = {
                    gridId,
                };
                let waylineInfo = null
                Api.getRouteList(param).then((res) => {
                    if (res.code == 200) {
                        let data = res.rows || []
                        waylineInfo = data[0]
                    }
                    resolve(waylineInfo)
                });
            })

        },
        handleLeftHeaderTabChange(tab) {
            if (tab == 3) {
                //3是网格，切换到网格列表时，清空航线信息

                this.routeObj = {
                    RouteValue: '',
                    lineType: '',
                    searchHive: {},
                    SeeShow: false,
                    airT: 0,
                    CurrentVal: {},
                    rightShow: false,
                    importState: false,
                    altitudeLayers: {},
                }
                this.airlineConfig = {}
            }
            this.hideRight();
        },
        showRight() {
            if (this.$refs.mainLayoutRef) {
                this.$refs.mainLayoutRef.toggleRight(true);
            }
        },
        hideRight() {
            if (this.$refs.mainLayoutRef) {
                this.$refs.mainLayoutRef.toggleRight(false);
            }
        },

        initData() {

            this.getSiteList();


        },
    },


    created() {
        this.initData();

        //处理从别的页面跳转过来的数据，如：后台管理的航线管理模块跳转过来
        let query = this.$route.query;
        const { routeId, type } = query;
        this.routeId = routeId;
        if (routeId) {
            if (type == 'edit') {
                this.$router.push({
                    path: `/route/edit/${routeId}`,

                })
                return
            } else if (type == 'detail') {
                this.getRouteInfo(routeId).then(data => {

                    if (data) {
                        this.viewRouteDetail(data)
                    }
                })
            }
        }




    },
    mounted() {
        this.hideRight();
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

@include b(airline, c) {
    width: 100%;
    height: calc(100%);
    box-sizing: border-box;
    position: relative;

    @include e(top) {
        position: absolute;
        top: 8px;
        left: 2px;
        width: calc(100% - 8px);
        height: 48px;
        background-color: #071150;
        z-index: 0;
        // border: 1px solid hsl(199, 73%, 54%);
        border-radius: 5px;

        &::after {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -2;
            position: absolute;
            top: 0px;
            left: 0px;
            background-color: #071150;
        }

        &::before {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -1;
            position: absolute;
            top: 0px;
            left: 0px;
            border: 24px solid;
            box-sizing: border-box;
            border-image: url(./imgs/bg_message.png) 24 24;
        }
    }

    @include e(main) {
        position: absolute;
        top: 66px;
        bottom: 8px;
        width: calc(100% - 10px);
        display: flex;

        .img-icon {
            position: absolute;
            align-self: center;
            z-index: 2;
        }

        // height: calc(100% - 82px);
    }

    @include e(left) {
        position: absolute;
        left: 5px;
        top: 0px;
        width: 330px;
        height: calc(100% - 4px);
        z-index: 0;
        // border: 1px solid hsl(199, 73%, 54%);
        background-color: #071150;
        border-radius: 5px;

        &::after {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -2;
            position: absolute;
            top: 0px;
            left: 0px;
            background-color: #071150;
        }

        &::before {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -1;
            position: absolute;
            top: 0px;
            left: 0px;
            border: 56px solid;
            box-sizing: border-box;
            border-image: url(./imgs/bg_wrap.png) 56 56;
        }
    }

    @include e(right) {
        position: absolute;
        right: 5px;
        top: 0px;
        // width: 334px;
        height: 100%;
        // border: 1px solid hsl(199, 73%, 54%);
        background-color: #071150;
        border-radius: 5px;

        // z-index: 0;
    }

    @include e(content) {
        position: absolute;
        top: 0px;
        height: calc(100% - 20px);
        padding: 8px 8px 8px 8px;

        background-color: #071150;
        z-index: 0;

        &::after {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -2;
            position: absolute;
            top: 0px;
            left: 0px;
            background-color: #071150;
        }

        &::before {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -1;
            position: absolute;
            top: 0px;
            left: 0px;
            border: 56px solid;
            box-sizing: border-box;
            border-image: url(./imgs/bg_wrap.png) 56 56;
        }
    }

    .show {
        width: 324px;
        display: block;
    }

    .hide {
        width: 0%;
        display: none;
    }
}
</style>
